import { IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from "@ionic/react";
import { briefcaseOutline, calendarOutline, documentTextOutline, peopleOutline, personOutline } from "ionicons/icons";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";
import SchedulePage from "../pages/SchedulePage.jsx";
import JobsPage from "../pages/JobsPage.jsx";
import ClientsPage from "../pages/ClientsPage.jsx";
import FinancePage from "../pages/FinancePage.jsx";
import InvoiceHistoryPage from "../pages/InvoiceHistoryPage.jsx";
import PayrollHistoryPage from "../pages/PayrollHistoryPage.jsx";
import ProfilePage from "../pages/ProfilePage.jsx";
import TeamsPage from "../pages/TeamsPage.jsx";
import TeamUsersPage from "../pages/TeamUsersPage.jsx";

export default function AppTabs() {
  const { session } = useAuth();
  const isAdmin = session?.role === "admin";

  return (
    <IonTabs>
      {isAdmin ? (
        <IonRouterOutlet>
          <Route exact path="/app/schedule" component={SchedulePage} />
          <Route exact path="/app/jobs" component={JobsPage} />
          <Route exact path="/app/clients" component={ClientsPage} />
          <Route exact path="/app/finance" component={FinancePage} />
          <Route exact path="/app/invoices" render={() => <Redirect to="/app/finance" />} />
          <Route exact path="/app/finance/invoices/history" component={InvoiceHistoryPage} />
          <Route exact path="/app/finance/payroll/history" component={PayrollHistoryPage} />
          <Route exact path="/app/profile" component={ProfilePage} />
          <Route exact path="/app/profile/teams" component={TeamsPage} />
          <Route exact path="/app/profile/teams/:teamId/users" component={TeamUsersPage} />
          <Route exact path="/app" render={() => <Redirect to="/app/schedule" />} />
        </IonRouterOutlet>
      ) : (
        <IonRouterOutlet>
          <Route exact path="/app/schedule" component={SchedulePage} />
          <Route exact path="/app/profile" component={ProfilePage} />
          <Route exact path="/app" render={() => <Redirect to="/app/schedule" />} />
        </IonRouterOutlet>
      )}

      <IonTabBar slot="bottom" className="metora-tabbar">
        <IonTabButton tab="schedule" href="/app/schedule">
          <IonIcon icon={calendarOutline} />
          <IonLabel>Schedule</IonLabel>
        </IonTabButton>
        {isAdmin && (
          <IonTabButton tab="jobs" href="/app/jobs">
            <IonIcon icon={briefcaseOutline} />
            <IonLabel>Jobs</IonLabel>
          </IonTabButton>
        )}
        {isAdmin && (
          <IonTabButton tab="clients" href="/app/clients">
            <IonIcon icon={peopleOutline} />
            <IonLabel>Clients</IonLabel>
          </IonTabButton>
        )}
        {isAdmin && (
          <IonTabButton tab="finance" href="/app/finance">
            <IonIcon icon={documentTextOutline} />
            <IonLabel>Finance</IonLabel>
          </IonTabButton>
        )}
        <IonTabButton tab="profile" href="/app/profile">
          <IonIcon icon={personOutline} />
          <IonLabel>Profile</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
}
